import { Checkbox } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import { FormGroup } from '@mui/material';
import IconButton from 'controls/IconButton';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Row } from 'saladsoft-primitive';
import { AdminListingImageDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';
import { useStoreWrapper } from 'stores/StoreHelper';

const ImageDetail = ({ listingId, image }: { listingId: number; image: AdminListingImageDto }) => {
  const { uiStore } = useStoreWrapper();
  const [isPlan, setIsPlan] = useState(image?.isPlan);

  const handleSave = () => {
    ServiceHelper?.adminListingService
      ?.updateListingImage(listingId, image?.id as number, {
        isPlan: isPlan,
      })
      .then((res) => {
        if (res.status < 300) {
          toast.success('저장되었습니다.');
        } else {
          toast.error('저장에 실패했습니다.');
        }
      })
      .finally(() => {
        uiStore?.modal.confirm();
      });
  };

  const handleDelete = () => {
    uiStore?.confirm.show({
      title: '삭제하시겠습니까?',
      onConfirmed: () => {
        ServiceHelper?.adminListingService
          ?.deleteListingImage(listingId, image?.id as number)
          .then((res) => {
            if (res.status < 300) {
              toast.success('삭제되었습니다.');
              uiStore.modal.confirm();
            }
          });
      },
    });
  };

  return (
    <>
      <Row>
        <img src={image.url} style={{ width: '100%', height: 'auto' }} />
      </Row>
      <div style={{ padding: '0px 20px' }}>
        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked={isPlan} onChange={(e) => setIsPlan(e.target.checked)} />}
            label="도면으로 지정"
          />
        </FormGroup>
      </div>
      <Row padding={20} justifyContent="space-between">
        <Row gap="10px">
          <Button type="outlined" onClick={() => uiStore?.modal.close()}>
            닫기
          </Button>
          <Button onClick={() => handleSave()}>저장하기</Button>
        </Row>

        <Row>
          <IconButton type="delete" onClick={() => handleDelete()}></IconButton>
        </Row>
      </Row>
    </>
  );
};

export default ImageDetail;
